module.exports = __webpack_public_path__ + "img/courses.401070f2.png";